// extracted by mini-css-extract-plugin
module.exports = {"Blockquote":"Blockquote_Blockquote__1hghZ","Blockquote__icon":"Blockquote_Blockquote__icon__3uCnb","Blockquote__content":"Blockquote_Blockquote__content__nu8OX"};